import SideMenu from '@/containers/side-menu/SideMenu.vue';
const TariffSchedule = () => import('@/pages/tariff-schedule/TariffSchedule.vue');

export default {
  path: '/tariff-schedule',
  name: 'TariffSchedule',
  components: {
    mainContent: TariffSchedule,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'tariff-schedule',
    },
    breadcrumb: {
      title: 'Serviço tarifário',
      paths: [{ title: 'Agenda tarifária' }],
    },
  },
};
